import AgencyClientsActionField from '@/components/agencies/sites/agency-clients-action-field';
import AgencyClientsActions from '@/components/agencies/sites/agency-clients-actions';
import CustomBlock from '@/components/common/custom-block/custom-block';
import ListStylesContainer from '@/components/common/list-container/list-styles-container';
import useGetGroupUser from '@/hooks/useGetGroupUser';
import { AVATARS, SITES_METADATA_AVATAR_TYPE_NAME } from '@/utils/CONST';
import Box from '@mui/material/Box';
import { Datagrid, DateField, FunctionField, List, TextField, TextInput, useTranslate } from 'react-admin';
import { Outlet, useParams } from 'react-router';

const AgencySitesList = () => {
    const translate = useTranslate();
    const { agencyId } = useParams();
    const { groupUser } = useGetGroupUser({ agencyId });

    const agencyGroupIds = groupUser?.groupAvatars;
    const hasGroupAvatars = !!agencyGroupIds && agencyGroupIds.length > 0;

    return (
        <CustomBlock label={translate('agency.list.sites.title')}>
            <ListStylesContainer>
                <List
                    actions={<AgencyClientsActions />}
                    component='div'
                    resource={AVATARS}
                    filter={{
                        'metadataAvatarType.name': SITES_METADATA_AVATAR_TYPE_NAME,
                        serialization_groups: ['read_group_users_group_avatars'],
                        enabled: true,
                        ...(hasGroupAvatars && {
                            'groupAvatars.id': agencyGroupIds,
                        }),
                    }}
                    sort={{
                        field: 'creationDate',
                        order: 'ASC',
                    }}
                    empty={false}
                    storeKey='agencyClientsList'
                    filters={[<TextInput source='name' label={'site.form.site_name'} variant='standard' resettable />]}
                    disableSyncWithLocation
                    queryOptions={{ enabled: hasGroupAvatars }}
                >
                    <Datagrid bulkActionButtons={false}>
                        <TextField label={'site.form.site_name'} source='name' />
                        <DateField label={'site.installation_date'} source='creationDate' />
                        <FunctionField
                            label={'site.form.address'}
                            render={(record: any) => {
                                const addressParts = [
                                    record?.addressText,
                                    record?.city,
                                    record?.postalCode,
                                    record?.country,
                                ].filter(Boolean);
                                return addressParts.length > 0 ? addressParts.join(', ') : '--';
                            }}
                        />

                        <Box display={'flex'} alignItems={'center'} gap={2}>
                            <FunctionField render={({ id }: any) => <AgencyClientsActionField clientId={id} />} />
                        </Box>
                    </Datagrid>
                </List>
            </ListStylesContainer>

            <Outlet />
        </CustomBlock>
    );
};

export default AgencySitesList;
